export default "assets/images/texture_map-ae86cb54.jpg";